import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./index.scss";

function Sidebar() {
    const dispatch = useDispatch();
    const [profileName]=useState(useSelector((state) => state?.LoginReducer?.user?.fullName ?? {}))
    const splitName=(fullName)=>{
        const [first] = (fullName && typeof fullName === 'string') ? fullName?.split(' ') : "";
        return first
    }
    
    const handleLogout = (e) => {
        e.preventDefault();
        dispatch({ type: 'LOGOUT_STATUS_SUCCESS' })
        localStorage.clear();
    } 

    return <>
        <div className="sidebar">
            <p><small>Welcome, {splitName(profileName)}!</small></p>
            <p><Link to="#">My Profile</Link><br /></p>
            <p><Link to="#">My Income</Link><br /></p>
            <p><Link to="#">Requests</Link><br /></p>
            <hr />
            <p><small>My Tasks</small></p>
            <p><Link to="#">In Progress</Link><br /></p>
            <p><Link to="#">Completed</Link><br /></p>
            <hr />
            <p><Link to="#">Resource Center</Link><br /></p>
            <p><Link to="#">Need Help?</Link><br /></p>
            <hr />
            <Link to="#" onClick={(e) => handleLogout(e)} className="text-muted">Logout</Link><br />
        </div>
    </>
}

export default Sidebar